import DocumentStatusContainer from './documentStatusContainer';
export default DocumentStatusContainer;
